
<div class="container-fuild p-4">


<h4 class="d-flex align-items-center justify-content-between">
  <span>Documentos por firmar</span>

  <small class="text-muted" *ngIf="totalItems">
    Mostrando {{ currentItems?.length || 0 }} de {{ totalItems }}
  </small>
</h4>

<hr class="mt-2 mb-3" />

<form [formGroup]="formSearch" >
  <div class="row align-items-center">
    <div class="col-md-6 col-sm-12">
      <div class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por: título"
          aria-label="Búsqueda por título"
          aria-describedby="btn-search"
          formControlName="search"
        />
        <button
          class="input-group-text"
          id="btn-search"
          type="submit"
          style="cursor: pointer;"
          [disabled]="spinner"
          (click)="search()"
        >
          <i class="fa fa-search" *ngIf="!spinner"></i>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            *ngIf="spinner"
          ></span>
        </button>
      </div>
    </div>

    <div class="col-md-6 col-sm-12 text-md-end text-start mb-3 mb-md-0">
      
    </div>
  </div>
</form>


<div class="table-responsive">
  <app-paginacion
    [currentPage]="currentPage"
    [totalItems]="totalItems"
    [selectedPageSize]="pageSize"
    [paginatedData]="currentItems"
    [headers]="tableHeaders"
    [actions]="customActions"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    [loading]="spinner"
  >
  </app-paginacion>
</div>


</div>

